import { PushNotifications } from '@capacitor/push-notifications';
import { Camera } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation'; // Import Geolocation
import { Capacitor } from '@capacitor/core';

export const requestAllPermissions = async () => {
    if (Capacitor.getPlatform() === 'web') {
        console.log("Web platform: Requesting permissions sequentially...");

        // 1. Notification
        const notifPerm = await Notification.requestPermission();
        console.log("Web Notification Permission:", notifPerm);

        // 2. Location (Web requires user context, but we can try)
        // navigator.geolocation.getCurrentPosition(() => {}, () => {});
        return;
    }

    // NATIVE PLATFORM
    try {
        console.log("Native platform: Requesting all permissions sequentially with transition delays...");

        // 1. Notifications
        const pushStatus = await PushNotifications.checkPermissions();
        if (pushStatus.receive === 'prompt') {
            await PushNotifications.requestPermissions();
        }
        
        // Wait 800ms for OS permission dialog transition
        await new Promise(resolve => setTimeout(resolve, 800));

        // 2. Camera & Photos
        const cameraStatus = await Camera.checkPermissions();
        if (cameraStatus.camera === 'prompt' || cameraStatus.photos === 'prompt') {
            await Camera.requestPermissions();
        }
        
        // Wait 800ms for OS permission dialog transition
        await new Promise(resolve => setTimeout(resolve, 800));

        // 3. Location (NEW)
        const locationStatus = await Geolocation.checkPermissions();
        if (locationStatus.location === 'prompt' || locationStatus.coarseLocation === 'prompt') {
            await Geolocation.requestPermissions();
        }

        console.log("All startup permissions requested sequentially.");

    } catch (e) {
        console.error("Error requesting permissions:", e);
    }
};
